<template>
  <section>
    <v-dialog
      v-model="value"
      width="800"
    >
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Template</span>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-body">
            <div class="form-item type-button pd-b-30">
              <el-form-item
                ref="enquiry_type"
                :rules="rules.select"
                prop="lang">
                <v-radio-group
                  v-model="formData.lang"
                  :list="lanuageList"/>
              </el-form-item>
            </div>
            <div class="form-item box pd-b-30">
              <el-form-item
                ref="select_index"
                :rules="rules.select"
                prop="select_index">

                <section class="select-type">
                  <label
                    v-for="(item,index) in list"
                    :key="index"
                    class="select-pay"
                    :class="{'checked':select_index==index}"
                    @click="handleTemplate(index)">
                    <el-radio
                      v-model="formData.select_index"
                      :label="index"
                      @change="handleChange"
                    >
                      <div  class="flex-align-center">
                        <span
                          class="select-span"
                          v-html="changeLineData(item[`content${formData.lang}`])"></span>
                      </div>
                    </el-radio
                    >
                  </label>
                </section>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <template>
          <div
            class="dialog-footer">
            <v-button
              gray
              @click="handleCancel">{{cancelText}}</v-button>
            <div>
              <v-button
                green
                @click="handleNext">
                {{btnText}}
              </v-button>
            </div>
          </div>
        </template>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import dayjs from 'dayjs'
import {mapActions, mapState} from 'vuex'
import {getEnquiryTemplateList} from '@api/enquiry'
export default {
  name: 'enquiryTemplateForm',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    cancelText:{
      type:String,
      default:'Cancel'
    },
    btnText:{
      type:String,
      default:'Confirm'
    },
  },
  data(){
    return{
      isShow:false,
      selectType:'',
      list:[],
      formData:{
        lang:'_hk',
        select_index:-1
      },
    }
  },
  computed: {
    lanuageList(){
      return [
        {
          id:'_hk',
          name:'中文'
        },
        {
          id:'_en',
          name:'English'
        }
      ]
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
        if(val){
          this.network().getEnquiryTemplateList()
        }
      }
    }
  },
  mounted() {

  },
  methods:{
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setSelectReferCustomerData','setReferCustomerId']),
    handleChange(index){
      this.index = index
    },
    handleTemplate(index){
      this.select_index = index
    },
    handleCancel(){
      this.$refs['form'].resetFields()
      this.$emit('input',false)
    },
    handleNext(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          let {select_index,lang} = this.formData
          let obj = this.list[select_index]||{}
          let message = obj[`content${lang}`]
          this.$emit('update:message',message)
          this.$emit('input',false)
        }

      })

    },
    network() {
      return {
        getEnquiryTemplateList: async () => {
          const {data} = await getEnquiryTemplateList()
          this.list = data.content||[]
        },
      }
    }
  },

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .width-80{
      width: 80px;
    }
    .type-button {
      // margin-right: 20px;
      padding-bottom: 30px;
      border-bottom: 0!important;
      margin-bottom: 0!important;
      /deep/ .el-radio-group{
        display: flex;
      }
      ::v-deep .el-radio {
        //margin-right: 23px;
        margin-top: 8px;
        width: 50%;
        .el-radio__label {
          display: inline-block;

          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
          margin-right: 23px;
        }
      }
    }
    /deep/ .el-date-editor{
      width: 100% !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .box{
    border: 1px solid #d1d5da;
    padding: 20px;
    border-radius: 5px;
    max-height: 468px;
    overflow-y: auto;
  }
  .form-item{
    .select-type{
      display: flex;
      flex-direction: column;
    }
  }
  .type-button {
    // margin-right: 20px;
    padding-bottom: 30px;
    border-bottom: 1px solid #D1D5DA;
    margin-bottom: 20px;
    /deep/ .el-radio-group{
      display: flex;
    }
    ::v-deep .el-radio {
      //margin-right: 23px;
      margin-top: 8px;
      width: 50%;
      .el-radio__label {
        display: inline-block;

        padding: 0px 10px;
        height: auto;
        //line-height: 30px;
        font-size: 12px;
        border-radius: 50px;
        border: 1px solid #E1E4E8;
        color: #24292E;
        background: white;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 18px;
        margin-left:8px ;
        margin-right: 23px;
      }
    }
  }
  .select-pay {
    border: 1px solid #d1d5da;
    border-radius: 5px;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 16px;
    width:100%;
    display: block;
    .el-radio{
      display: flex;
      align-items: center;
    }
    &.checked{
      border-color: #409EFF;
    }
    .select-span {
      color: #24292e;
      font-family: Inter;
      font-size: 14px;
      white-space: normal;
    }
    .icon-block{
      display: block;
      width: 42px;
      height: 42px;
      margin: 0 20px;
      img{
        width: 42px;
      }
    }
    .margin-top {
      margin-top: 20px;
    }
  }
}
</style>
